import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Carhireforoutstaioninmumbai() {



const cardData = {
  keyword: " Car Hire for Outstation in Mumbai",

headingDescription:
  "Omshree Cab offers reliable and comfortable car hire for outstation travel in Mumbai, specially designed for travelers who want smooth, safe, and hassle‑free journeys to nearby cities, hill stations, beaches, pilgrimage sites, and popular destinations across and beyond Maharashtra. Whether you’re planning a weekend getaway, family vacation, corporate travel, or spiritual trip, our outstation car hire service ensures a pleasant driving experience with experienced chauffeurs and well‑maintained vehicles. We provide flexible booking options including one‑way rides, round trips, and multi‑day packages with transparent per‑kilometer pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, multi‑purpose vehicles (MPVs), and tempo travelers suitable for solo travelers, families, groups, and corporate clients. With easy online booking, punctual pickups from any location in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for outstation car hire services.",

topPlaces: [
  {
    title: "Pune",
    description:
      "Pune is a vibrant cultural and historical city near Mumbai known for its forts, gardens, historic sites like Shaniwar Wada, and attractions like Aga Khan Palace and Sinhagad Fort. It’s also a hub for cafes, shopping, and nightlife, making it a perfect weekend destination. Hiring a car for outstation travel from Mumbai lets you enjoy a comfortable drive via the Mumbai‑Pune Expressway with scenic views, timely stops, and flexible sightseeing options along the way."
  },
  {
    title: "Lonavala & Khandala",
    description:
      "Lonavala and Khandala are popular hill stations near Mumbai known for cool weather, lush valleys, waterfalls, viewpoints like Tiger’s Leap, and picnic spots like Bushi Dam. They are ideal for weekend trips and nature retreats. An outstation car hire gives you the freedom to explore these hill destinations at your own pace, take scenic breaks, and enjoy photo stops without rushing your itinerary."
  },
  {
    title: "Mahabaleshwar & Panchgani",
    description:
      "Mahabaleshwar and Panchgani are famous hill stations offering strawberry farms, panoramic viewpoints like Arthur’s Seat and Table Land, and pleasant climates throughout the year. Families and couples often visit for scenic walks, boating, and local produce tasting. Using a car hire for outstation travel from Mumbai enables you to plan an extended trip with flexibility, comfortable journey time, and ample stops for sightseeing and refreshments."
  },
  {
    title: "Alibaug",
    description:
      "Alibaug is a serene coastal town known for its sandy beaches, relaxed vibe, and historic sites like Kolaba Fort. Popular beaches include Nagaon Beach, Varsoli Beach, and Kihim Beach. An outstation car hire from Mumbai lets you enjoy a comfortable coastal drive with flexibility in beach activities, photography, beachside dining, and sunset views without relying on public transport or ferries."
  },
  {
    title: "Goa",
    description:
      "Goa is one of India’s most famous beach destinations with golden sands, water sports, historic churches, vibrant nightlife, and seafood cuisine. Hiring a car for an outstation trip from Mumbai to Goa provides a scenic coastal drive along the Konkan coast, with opportunities to explore lesser‑known beaches, roadside viewpoints, and local villages en route to the main attractions."
  },
  {
    title: "Shirdi",
    description:
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, where devotees come for darshan, aarti, and spiritual experiences. The town also offers local markets and spiritual experiences beyond the temple. Hiring a car for outstation travel provides a comfortable and flexible journey from Mumbai, allowing you to plan rest stops, sightseeing, and devotional activities without transport hassles."
  },
  {
    title: "Nashik",
    description:
      "Nashik is known for its spiritual sites like Trimbakeshwar Temple, as well as its vineyards like Sula Vineyards, Godavari river ghats, and cultural heritage. Visitors enjoy temple visits, wine tours, riverfront sunsets, and historical spots. Outstation car hire from Mumbai provides reliable travel that lets you explore religious, cultural, and leisure experiences without worrying about local transport."
  },
  {
    title: "Kolhapur",
    description:
      "Kolhapur is a historic city with attractions such as the Mahalakshmi Temple, Rankala Lake, and vibrant local cuisine known for Kolhapuri specialties. It’s a destination suited for cultural experiences, temple visits, and leisurely exploration. Car hire for outstation travel ensures a comfortable and private journey from Mumbai, with flexibility in pacing your itinerary and stops along the route."
  },
  {
    title: "Aurangabad & Caves",
    description:
      "Aurangabad is home to the world‑famous Ajanta and Ellora Caves — UNESCO World Heritage Sites known for their ancient rock‑cut architecture and intricate carvings. The city also features historic palaces, forts, and museums. Hiring a car for a longer outstation journey gives you a peaceful and comfortable drive from Mumbai, perfect for rediscovering history and archaeology at your own pace."
  },
  {
    title: "Konkan Coast Drive",
    description:
      "The scenic Konkan Coast Drive from Mumbai takes you through pristine beaches, forts, waterfalls, fishing villages, and lush greenery along the western coast of India. Highlights include Ganpatipule, Ratnagiri, Velas Turtle Beach, and Tarkarli. An outstation car hire lets you customize the route with flexible stops, local seafood experiences, hidden coastal spots, and scenic photography breaks for an unforgettable road trip."
  }
],



services: [
{
name: "Car Hire for Outstation Mumbai",
description: "Car hire for outstation travel in Mumbai provides convenient transportation for travelers planning trips outside the city. Vehicles are well maintained and suitable for long-distance highway travel to destinations across Maharashtra and India. Professional drivers ensure punctual pickup and safe driving services from homes, offices, hotels, railway stations, and airport terminals. Ideal for weekend getaways, temple visits, family vacations, and business trips. Air-conditioned vehicles ensure comfortable journeys during long drives. Flexible booking options allow passengers to plan outstation trips easily."
},
{
name: "Outstation Car Rental Mumbai",
description: "Outstation car rental in Mumbai offers reliable vehicle hire services for travelers planning long-distance journeys from the city. Rental vehicles are suitable for highway travel and multi-day trips across different states. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family trips, and corporate journeys. Comfortable seating ensures relaxed travel experiences. Flexible booking options allow convenient outstation travel planning."
},
{
name: "Outstation Car Hire Mumbai",
description: "Outstation car hire in Mumbai provides dependable transportation solutions for passengers traveling to nearby cities and tourist destinations. Vehicles are well maintained and suitable for extended highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for family vacations, pilgrimage tours, and corporate travel. Spacious vehicles ensure comfortable journeys. Flexible booking options allow passengers to reserve vehicles easily."
},
{
name: "Mumbai Long Distance Taxi",
description: "Mumbai long distance taxi service offers comfortable transportation for travelers planning extended journeys beyond city limits. Vehicles are designed for highway travel and long-distance routes across multiple states. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for interstate travel, family vacations, and corporate trips. Air-conditioned vehicles ensure comfortable journeys during long drives. Flexible booking options allow easy travel scheduling."
},
{
name: "Mumbai Intercity Cab Service",
description: "Mumbai intercity cab service provides reliable transportation between Mumbai and nearby cities and tourist destinations. Vehicles are suitable for highway travel and offer comfortable seating for long-distance journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for business travel, family trips, and tourism visits. Spacious interiors ensure relaxed journeys for passengers. Flexible booking options allow convenient intercity travel planning."
},
{
name: "Car Rental for Outstation Mumbai",
description: "Car rental for outstation travel in Mumbai provides convenient vehicle hire services for travelers planning trips outside the city. Rental vehicles are suitable for long-distance highway travel and extended journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for pilgrimage tours, weekend trips, and business travel. Comfortable interiors ensure relaxed travel experiences. Flexible booking options allow easy ride reservations."
},
{
name: "Best Outstation Car Hire Mumbai",
description: "Best outstation car hire in Mumbai offers reliable transportation services with well-maintained vehicles and professional drivers. Travelers can enjoy comfortable journeys to destinations across Maharashtra and India. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for family vacations, corporate trips, and temple tours. Comfortable vehicles ensure smooth travel experiences on long-distance highways. Professional service ensures punctual pickups and safe travel. Flexible booking options allow easy travel planning."
},
{
name: "Cheap Outstation Car Rental Mumbai",
description: "Cheap outstation car rental in Mumbai offers affordable transportation for travelers looking for economical long-distance travel options. Budget-friendly vehicles provide comfortable seating and reliable highway performance. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for students, budget travelers, and families planning economical trips. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow cost-effective travel planning."
},
{
name: "Mumbai Outstation Car Booking",
description: "Mumbai outstation car booking allows travelers to easily reserve vehicles for intercity and long-distance journeys. Online and phone booking options provide quick confirmation and convenient scheduling. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, business trips, and family journeys. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow easy ride reservations."
},
{
name: "Innova Car Hire Outstation Mumbai",
description: "Innova car hire for outstation travel in Mumbai provides spacious and comfortable MPV transportation for long-distance journeys. The Toyota Innova offers premium seating, smooth highway performance, and ample luggage space. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for family vacations, pilgrimage tours, and corporate travel. Comfortable interiors ensure relaxed journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Sedan Car Hire Outstation Mumbai",
description: "Sedan car hire for outstation travel in Mumbai provides economical and comfortable transportation for long-distance journeys. Sedan vehicles offer smooth driving performance and comfortable seating suitable for intercity travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business trips, tourism travel, and airport transfers. Air-conditioned vehicles ensure relaxed journeys. Flexible booking options allow easy reservations."
},
{
name: "SUV Car Rental Outstation Mumbai",
description: "SUV car rental for outstation travel in Mumbai offers powerful and spacious vehicles suitable for long-distance highway journeys. SUVs provide comfortable seating and large luggage capacity ideal for family trips and group travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for adventure trips, tourism travel, and long-distance family journeys. Spacious interiors ensure comfortable travel experiences. Flexible booking options allow convenient ride reservations."
},
{
name: "Luxury Outstation Car Mumbai",
description: "Luxury outstation car service in Mumbai provides premium transportation for travelers seeking stylish and comfortable long-distance journeys. Luxury vehicles offer elegant interiors, spacious seating, and smooth highway performance. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for VIP travel, corporate executives, and special journeys. Premium interiors ensure relaxing travel experiences. Flexible booking options allow convenient luxury travel planning."
},
{
name: "Outstation Car Rental Per Km Mumbai",
description: "Outstation car rental per km in Mumbai provides transparent pricing for passengers traveling long distances outside the city. Per kilometer pricing allows travelers to pay based on the actual distance traveled. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business trips, tourism visits, and family travel. Comfortable vehicles ensure relaxed journeys. Clear pricing structure ensures affordable and transparent fares."
},
{
name: "Family Trip Car Rental Mumbai",
description: "Family trip car rental in Mumbai provides spacious and comfortable vehicles suitable for family vacations and group travel. Vehicles offer comfortable seating and luggage space for extended journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, railway stations, and airport terminals. Ideal for holiday travel, sightseeing tours, and temple visits. Comfortable interiors ensure enjoyable journeys for families. Flexible booking options allow convenient travel planning."
}
],

tableData: [
["Car Hire for Outstation Mumbai","Outstation Car Rental Mumbai"],
["Outstation Car Hire Mumbai","Mumbai Long Distance Taxi"],
["Mumbai Intercity Cab Service","Car Rental for Outstation Mumbai"],
["Best Outstation Car Hire Mumbai","Cheap Outstation Car Rental Mumbai"],
["Mumbai Outstation Car Booking","Innova Car Hire Outstation Mumbai"],
["Sedan Car Hire Outstation Mumbai","SUV Car Rental Outstation Mumbai"],
["Luxury Outstation Car Mumbai","Outstation Car Rental Per Km Mumbai"],
["Family Trip Car Rental Mumbai","Best Intercity Car Hire Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Outstation Travel Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in long-distance travel from Mumbai to various destinations across Maharashtra and India. They are familiar with highways, ghat sections, and popular tourist routes, ensuring safe and smooth outstation journeys."
  },
  {
    WhyChooseheading: "Transparent Outstation Car Hire Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for outstation car hire in Mumbai. Customers receive clear details about per-kilometer rates, toll charges, and driver allowances so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Car Hire Booking Service",
    WhyChoosedescription: "Our outstation car hire service in Mumbai is available 24 hours a day. Whether you want an early morning departure or a late-night pickup, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All our vehicles are well maintained, regularly cleaned, and fully air-conditioned. This ensures passengers enjoy a comfortable and relaxing journey during long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Outstation Travel Packages",
    WhyChoosedescription: "We provide flexible outstation travel options including one-way cabs, round-trip bookings, and multi-day travel packages from Mumbai to destinations like Pune, Shirdi, Nashik, Surat, and Goa."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers multiple vehicle options including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and groups."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports across Mumbai so your outstation trip starts comfortably and on time."
  },
  {
    WhyChooseheading: "Reliable Outstation Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for outstation car hire in Mumbai. Our punctual drivers, well-maintained vehicles, and professional service ensure a stress-free travel experience."
  }
]
};

const faqData = [
  { question: "Do you provide outstation car hire services in Mumbai?", answer: "Yes, Omshree Cabs provides reliable outstation car hire services from Mumbai to destinations across Maharashtra and India." },
  { question: "Can I book a one-way outstation cab from Mumbai?", answer: "Yes, we offer both one-way and round-trip car hire services for outstation travel from Mumbai." },
  { question: "Which vehicles are available for outstation travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on the group size." },
  { question: "Is the outstation cab service available 24 hours?", answer: "Yes, our outstation cab service operates 24/7 to support flexible travel schedules." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for passenger comfort." },
  { question: "Can we take stops during the journey?", answer: "Yes, passengers can request stops for meals, sightseeing, or rest breaks during the journey." },
  { question: "Is advance booking required for outstation travel?", answer: "Advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Do you provide airport pickup for outstation trips?", answer: "Yes, we provide direct pickup from Mumbai Airport for outstation cab bookings." },
  { question: "Do you offer multi-day travel packages?", answer: "Yes, we provide customized multi-day travel packages from Mumbai for tourism and business travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to maintain hygiene and passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Deshmukh",
    feedback:
      "We hired a car from Omshree Cabs for our Mumbai to Mahabaleshwar trip. The car was clean and the driver was very professional. Highly recommended service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback:
      "Excellent outstation car hire service in Mumbai. Comfortable vehicle, punctual driver, and smooth travel experience.",
    rating: 5
  }
];














































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Hire for Outstation in Mumbai",
  "description": "Omshree Cab provides car hire services for outstation travel from Mumbai, including long-distance, intercity, and family trips. Choose from Innova, Sedan, SUV, and luxury vehicles for comfortable, safe, and budget-friendly journeys. Our flexible booking options and transparent per km rates make outstation travel hassle-free and reliable.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1950"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Car Hire for Outstation in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers car hire for outstation trips from Mumbai with Innova, Sedan, SUV, and luxury vehicles. Safe, comfortable, budget-friendly travel for long-distance, intercity, and family trips with transparent per km rates." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Carhireforoutstaioninmumbai;